export default __webpack_public_path__ + "static/media/closet4-480w.b95c10ba.webp";